import React, { PureComponent } from 'react';

class NavList extends PureComponent {
  render() {
    const {className = ''} = this.props;

    return (
      <div className={`nav-list ${className}`}>{this.props.children}</div>
    );
  }
}

export default NavList;



// WEBPACK FOOTER //
// ./js/components/global/menu/NavList.js